import { Box, MenuItem, Select, SelectChangeEvent } from "@mui/material";

type Props = {
  value: string | string[];
  setValue: any;
  options: { label: string; value: number }[];
  name: string;
  errors: any;
  multiple?: boolean;
  required?: boolean;
  label: string;
};

const SelectM = ({
  value,
  setValue,
  options,
  name,
  errors,
  multiple,
  required,
  label,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <label>
        {label} {required && <span>*</span>}
      </label>
      <Select
        multiple={multiple}
        sx={{ height: "36px" }}
        //@ts-ignore
        value={value}
        onChange={(e: SelectChangeEvent) => {
          setValue(name, e.target.value, {
            shouldValidate: true,
          });
        }}
      >
        {options.map(
          ({
            label,
            value,
          }: {
            value: string | number | readonly string[] | undefined;
            label: string;
          }) => (
            <MenuItem value={value}>{label}</MenuItem>
          )
        )}
      </Select>
      <Box color="red" fontSize="12px" height="18px">
        {errors[name]?.message && errors[name]?.message}
      </Box>
    </Box>
  );
};

export default SelectM;
